// app/javascript/projects/components/ProjectsDisplay.jsx

import React from 'react';
import {Pagination} from 'ui';
import { useHistory, useLocation } from 'react-router-dom';
import UrlUtil from 'utils/UrlUtil';

function TranscriptPager(props) {
  const history = useHistory();
  const location = useLocation();

  const onPage = (page) => {
    if ( page ) {
      const url = UrlUtil.setPage(page, location);
      history.push(url);
      props.onPage(page)
    }
  };

  let items = [];
  const currentPageNumber = UrlUtil.getPageNumber(location);
  const pageCount = props.pageCount;
  const previousDisabled = currentPageNumber <= 1;

  items.push(<Pagination.Prev
    key={0}
    onClick={()=>onPage(currentPageNumber - 1)}
    disabled={previousDisabled}
    />
  );

  for (let number = 1; number <= pageCount; number++) {
    items.push(
      <Pagination.Item
        key={number}
        active={number === currentPageNumber}
        onClick={()=>onPage(number)}>
        {number}
      </Pagination.Item>,
    );
  }

  const nextDisabled = currentPageNumber == pageCount;

  items.push(<Pagination.Next
    key={pageCount + 1}
    onClick={()=>onPage(nextDisabled ? null : currentPageNumber + 1)}
    disabled={nextDisabled}
  />)

  return (<Pagination style={{
                paddingBottom: "0px",
                marginBottom: "0px",
                marginTop: "0px",
                paddingTop: "0px",
              }}>
                {items}
          </Pagination>)
}

export default TranscriptPager;
